export var RenderType;
(function (RenderType) {
    RenderType[RenderType["Primary"] = 0] = "Primary";
    RenderType[RenderType["Secondary"] = 1] = "Secondary";
})(RenderType || (RenderType = {}));
//# sourceMappingURL=types.js.map